
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#F2994A"}}),_c('g',{attrs:{"clip-path":"url(#clip0_7625_15215)","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M26 22v-7.875c0-.298-.115-.585-.32-.796a1.074 1.074 0 00-.77-.329h-9.82c-.288 0-.566.118-.77.33-.205.21-.32.497-.32.795V22"}}),_c('path',{attrs:{"d":"M27.131 21.105a.58.58 0 01.57-.054.51.51 0 01.22.183c.053.08.08.172.079.266v6.495a.975.975 0 01-.313.71c-.2.19-.472.295-.755.295H13.068c-.283 0-.555-.106-.755-.294a.975.975 0 01-.313-.71V21.5a.467.467 0 01.08-.266.51.51 0 01.22-.183.58.58 0 01.569.054l5.824 3.95c.376.278.84.428 1.318.428.477 0 .941-.15 1.317-.427l5.803-3.951zM23 18h3M14 18h4M20.083 20.167a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7625_15215"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 11)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    